import { render, staticRenderFns } from "./SubmitStep.vue?vue&type=template&id=89f22bca&scoped=true&"
import script from "./SubmitStep.vue?vue&type=script&lang=js&"
export * from "./SubmitStep.vue?vue&type=script&lang=js&"
import style0 from "./SubmitStep.vue?vue&type=style&index=0&id=89f22bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f22bca",
  null
  
)

export default component.exports